import { render, staticRenderFns } from "./PhoneNumbersProperty.vue?vue&type=template&id=40989778"
import script from "./PhoneNumbersProperty.vue?vue&type=script&lang=js"
export * from "./PhoneNumbersProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports